import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import { Form } from 'informed';
import { useWindowSize } from '@magento/peregrine/lib/hooks/useWindowSize';
import TextInput from '@magento/venia-ui/lib/components/TextInput';
import Trigger from '@magento/venia-ui/lib/components/Trigger';
import RequestRevitModal from './requestRevitModal';
import Field from '../../overrides/venia-ui/components/Field';
import CategoryFilter from './categoryFilter';
import ResourcesList from './resourcesList';
import { AppBodyLayout, SearchIcon } from '../../components';
import RequestRevitForm from './requestRevitForm';
import { debounce } from '../../Utils/utils';
import defaultClasses from './resourcesContent.module.css';
import ResourcesCategory from './resourcesCategory';
import ImagesResults from './imagesResults';
import { getCustomerGroup } from '../../Utils/utils';
import { useUserContext } from '@magento/peregrine/lib/context/user/';

var ResourcesContent = function ResourcesContent(_ref) {
  var _productResourcesData, _imagesData$items, _imagesData$items2;

  var activeTabData = _ref.activeTabData,
      handleCheckboxClick = _ref.handleCheckboxClick,
      resetSelectedSubcategories = _ref.resetSelectedSubcategories,
      selectedSubcategories = _ref.selectedSubcategories,
      searchResourcesResult = _ref.searchResourcesResult,
      handleSearchSubmit = _ref.handleSearchSubmit,
      handleSearchImage = _ref.handleSearchImage,
      imagesData = _ref.imagesData,
      setFormApi = _ref.setFormApi,
      productResourcesData = _ref.productResourcesData;

  var _useWindowSize = useWindowSize(),
      innerWidth = _useWindowSize.innerWidth;

  var search = React.createElement(SearchIcon, null);
  var isSmallDevice = innerWidth < 640;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormModalOpen = _useState2[0],
      setIsFormModalOpen = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      searchData = _useState4[0],
      setSearch = _useState4[1];

  var _useUserContext = useUserContext(),
      _useUserContext2 = _slicedToArray(_useUserContext, 1),
      isUserSignedIn = _useUserContext2[0].isSignedIn;

  var _getCustomerGroup = getCustomerGroup(),
      isConsumer = _getCustomerGroup.isConsumer;

  var loggedNotConsumer = isUserSignedIn && !isConsumer;
  var subcategoryVideoTutorials = 'Video Tutorials';
  var paramsId = new URLSearchParams(location.search).get('id');
  useEffect(function () {
    return setSearch('');
  }, [activeTabData]);
  useEffect(function () {
    if (paramsId === 'videoTutorials' && loggedNotConsumer) {
      var item = activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.sub_category.find(function (subcategory) {
        return subcategory.name === 'Video Tutorials';
      });
      handleCheckboxClick(item);
    }
  }, []);

  var handleCloseFormModal = function handleCloseFormModal() {
    return setIsFormModalOpen(false);
  };

  var handleInputChange = debounce(function (data) {
    return handleSearchSubmit(data);
  }, 250);
  var handleInputImageSearch = debounce(function (data) {
    return handleSearchImage(data);
  }, 250);
  var queryParams = new URLSearchParams(location.search).get('tab');
  var formLink = isSmallDevice ? React.createElement(React.Fragment, null, React.createElement(Trigger, {
    action: function action() {
      return setIsFormModalOpen(true);
    },
    classes: {
      root: 'underline'
    },
    "aria-label": "Click for request form below for the specific product you\u2019re looking for"
  }, "Click Here"), "to complete") : React.createElement(React.Fragment, null, " Complete ");
  var titleText;

  switch (activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.category_id) {
    case 3:
      titleText = 'Need a specific 2D or 3D CAD file for your project? Just enter the Base Item # below.';
      break;

    default:
      titleText = 'Need a specific ' + (activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.name) + ' file for your project? Just enter the Base Item # below.';
      break;
  }

  return React.createElement(React.Fragment, null, activeTabData !== null && activeTabData !== void 0 && activeTabData.sub_category ? React.createElement("div", {
    className: defaultClasses.resourcesBackground
  }, React.createElement(AppBodyLayout, {
    classes: {
      body: 'grid grid-cols-12 gap-x-4'
    }
  }, React.createElement(CategoryFilter, {
    subCategories: activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.sub_category,
    handleCheckboxClick: handleCheckboxClick,
    resetSelectedSubcategories: resetSelectedSubcategories,
    selectedSubcategories: selectedSubcategories,
    loggedNotConsumer: loggedNotConsumer,
    subcategoryVideoTutorials: subcategoryVideoTutorials
  }), React.createElement(ResourcesList, {
    categoryId: activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.category_id,
    subCategories: selectedSubcategories.length ? selectedSubcategories : activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.sub_category,
    loggedNotConsumer: loggedNotConsumer,
    subcategoryVideoTutorials: subcategoryVideoTutorials
  }))) : React.createElement("div", {
    className: "container pt-10 flex flex-col items-center"
  }, React.createElement("h3", {
    className: "mb-8 text-black"
  }, activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.name), React.createElement("h6", {
    className: "mb-2.5 text-center text-black"
  }, titleText), React.createElement("p", {
    className: "xl_w-7/12 2xl_w-6/12 mb-8 text-center text-bronze"
  }, activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.description), React.createElement("div", {
    className: defaultClasses.resultsWrapper
  }, React.createElement(Form, {
    getApi: setFormApi,
    className: "mb-10 w-full sm_w-5/12 ",
    onSubmit: function onSubmit(data) {
      return handleSearchSubmit(data);
    },
    onChange: function onChange(data) {
      if (data.values.search) {
        if (queryParams === 'Image Assets') {
          handleInputImageSearch(data.values.search);
        } else {
          handleInputChange(data.values);
        }
      }
    }
  }, React.createElement(Field, {
    id: "search",
    label: "search"
  }, React.createElement(TextInput, {
    field: "search",
    id: "search",
    placeholder: "Search by Base Item # (minimum 6 digits)",
    after: search,
    classes: {
      input: defaultClasses.searchInputField
    },
    onChange: function onChange(e) {
      return setSearch(e.target.value);
    },
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Enter' && e.preventDefault();
    }
  }))), ((!searchResourcesResult || !(productResourcesData !== null && productResourcesData !== void 0 && (_productResourcesData = productResourcesData.items) !== null && _productResourcesData !== void 0 && _productResourcesData.length)) && (activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.category_id) !== 7 || !(imagesData !== null && imagesData !== void 0 && (_imagesData$items = imagesData.items) !== null && _imagesData$items !== void 0 && _imagesData$items.length) && (activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.category_id) === 7) && (searchData === null || searchData === void 0 ? void 0 : searchData.length) > 5 ? React.createElement(React.Fragment, null, React.createElement("div", {
    className: "mb-14 sm_w-8/12 bg-snowbound pt-7 pb-8 text-bronze"
  }, React.createElement("p", {
    className: "mb-4 px-9 sm_pl-10 sm_pr-10 text-center"
  }, "We are sorry, we couldn\u2019t find any results. Please double-check that the Base Item # you entered is correct."), React.createElement("p", {
    className: "px-9 sm_pl-24 sm_pr-32 text-center"
  }, "If your Base Item # is correct, we may not currently have a\n                                        ".concat((activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.category_id) === 7 ? 'Image' : 'Revit/CAD', " file available."), formLink, "the request form below for the specific product you\u2019re looking for.")), React.createElement(RequestRevitModal, {
    isOpen: isSmallDevice ? isFormModalOpen : false,
    closeModal: handleCloseFormModal
  }), !isSmallDevice ? React.createElement(RequestRevitForm, null) : null) : null, (searchResourcesResult === null || searchResourcesResult === void 0 ? void 0 : searchResourcesResult.length) && (searchData === null || searchData === void 0 ? void 0 : searchData.length) > 5 && React.createElement(ResourcesCategory, {
    subCategory: {
      name: 'Search Results'
    },
    categoryId: activeTabData === null || activeTabData === void 0 ? void 0 : activeTabData.category_id,
    showDownloadAll: false,
    resources: searchResourcesResult,
    classes: {
      categoryWrapper: defaultClasses.categoryWrapperPartial
    }
  }), imagesData !== null && imagesData !== void 0 && (_imagesData$items2 = imagesData.items) !== null && _imagesData$items2 !== void 0 && _imagesData$items2.length && (searchData === null || searchData === void 0 ? void 0 : searchData.length) > 5 && queryParams === 'Image Assets' ? React.createElement(ImagesResults, {
    imagesData: imagesData
  }) : null)));
};

export default ResourcesContent;